import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/css/reset.css'
import '@/assets/css/rich-content.css'

// 混入
import _mixin from '@/mixins/index.js'
Vue.mixin(_mixin)

// axios
import { api } from '@/utils/request'
Vue.prototype.$api = api

// 各种工具
import { cloneDeep, isPhone, isEmail, isArray, isObj } from '@/utils/index'
Vue.prototype.$cloneDeep = cloneDeep
Vue.prototype.$isPhone = isPhone
Vue.prototype.$isEmail = isEmail
Vue.prototype.$isArray = isArray
Vue.prototype.$isObj = isObj

// 可终止的forEach，return false 即可终止
Array.prototype.forEachBreakable = function (callback) {
    for (let i = 0; i < this.length; i++) {
        if (callback(this[i], i, this) === false) {
            break
        }
    }
}

Vue.config.productionTip = false

// 国际化
import zh from './langurage/zh.js' //中文
import en from './langurage/en.js' //英文
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import locale_ui_zh from 'element-ui/lib/locale/lang/zh-CN' //组件中文
import locale_ui_en from 'element-ui/lib/locale/lang/en' //组件英文
const messages = {
    zh: {
        ...zh,
        ...locale_ui_zh,
    },
    en: {
        ...en,
        ...locale_ui_en,
    },
}

let locale = 'zh' // zh、en
const i18n = new VueI18n({
    locale: locale,
    messages,
})

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, {
    locale_ui_zh,
    locale_ui_en,
    i18n: (k, v) => i18n.t(k, v),
})

// loading封装
import { Loading } from 'element-ui'
import { Message } from 'element-ui'
Vue.prototype.$load = {
    loading: null,
    open: function (type) {
        this.loading = Loading.service({
            fullscreen: true,
            text: i18n.t('加载中'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
    },
    close: function () {
        if (!this.loading) return false
        this.loading.close()
    },
}

// 消息封装
window.alertSucc = function (message) {
    Message.success({
        message,
        offset: 300,
        duration: 1500,
    })
}
window.alertErr = function (message) {
    Message.error({
        message,
        offset: 300,
        duration: 1500,
    })
}

// swiper
let Swiper = require('@/assets/js/swiper-bundle.min')
Vue.prototype.$Swiper = Swiper

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
